import { Controller } from "react-hook-form";
import TextField from "@mui/material/TextField";
import { FormInputProps } from "./FormInputProps";

export const FormInputText = ({ name, control, label, required = false, type = "text", min=0, max=0, maxLength=0 }: FormInputProps) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={{ 
        required: required ? `${label} is required` : false,
        min: type === "number" && min !== 0 ? { value: min, message: `Minimum value is ${min}` } : undefined,
        max: type === "number" && max !== 0 ? { value: max, message: `Maximum value is ${max}` } : undefined,
        maxLength: type === "number" && maxLength !== 0 ? { value: maxLength, message: `Maximum length is ${maxLength}` } : undefined
      }}  // Use the required prop
      render={({
        field: { onChange, value },
        fieldState: { error },
      }) => (
        <TextField
          //helperText={error ? error.message : null}
          size="small"
          error={!!error}
          onChange={onChange}
          className="mb-3"
          value={value}
          fullWidth
          label={label}
          variant="outlined"
          type={type}
          inputProps={{
            min: min !== 0 ? min : undefined,
            max: max !== 0 ? max : undefined,
            maxLength: maxLength !== 0 ? maxLength : undefined,
          }}
        />
      )}
    />
  );
};
